import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

import history from '../../utils/history';

function VPNModal({ open, onStartExam }) {
  const handleOnClose = () => {
    history.push('/app/dashboard');
  };

  return (
    <div>
      <Modal
        isOpen={open}
        className="practice-exam-popup modal-dialog-centered"
      >
        <ModalHeader tag="div" toggle={handleOnClose} className="dark">
          <h4 data-test="practice-exam-timer-test">Practice exam timer</h4>
        </ModalHeader>
        <ModalBody>
          <b className="danger">WARNING</b>
          <p>
            Practice Exams and Daily Quizzes may not work correctly if you
            switch devices while doing them. If you switch to a different
            device, we recommend the following:
          </p>
          <ul className="text-left">
            <li>Use the same time zone and time on both devices.</li>
            <li>Use the same VPN configuration, if you are using one.</li>
          </ul>
          <Button
            color="primary"
            size="xs"
            block
            data-test="start-exam-button"
            onClick={onStartExam}
          >
            START THE EXAM
          </Button>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default VPNModal;
